/**
 * bibleReferenceParser.js
 * Pure JS Bible reference parser for Spanish Adventist context.
 * Handles: "Juan 3:16", "1 Corintios 13:1-13", "Salmo 23", "Ap 21:1-4"
 */

// Full name → canonical name map (handles abbreviations + variants)
const BOOK_ALIASES = {
  // Pentateuco
  "génesis": "Génesis", "genesis": "Génesis", "gén": "Génesis", "gen": "Génesis", "gn": "Génesis",
  "éxodo": "Éxodo", "exodo": "Éxodo", "éx": "Éxodo", "ex": "Éxodo",
  "levítico": "Levítico", "levitico": "Levítico", "lev": "Levítico", "lv": "Levítico",
  "números": "Números", "numeros": "Números", "núm": "Números", "num": "Números", "nm": "Números",
  "deuteronomio": "Deuteronomio", "deut": "Deuteronomio", "dt": "Deuteronomio",
  // Históricos
  "josué": "Josué", "josue": "Josué", "jos": "Josué",
  "jueces": "Jueces", "jue": "Jueces",
  "rut": "Rut", "rt": "Rut",
  "1 samuel": "1 Samuel", "1samuel": "1 Samuel", "1 sam": "1 Samuel", "1s": "1 Samuel",
  "2 samuel": "2 Samuel", "2samuel": "2 Samuel", "2 sam": "2 Samuel", "2s": "2 Samuel",
  "1 reyes": "1 Reyes", "1reyes": "1 Reyes", "1 re": "1 Reyes", "1re": "1 Reyes",
  "2 reyes": "2 Reyes", "2reyes": "2 Reyes", "2 re": "2 Reyes", "2re": "2 Reyes",
  "1 crónicas": "1 Crónicas", "1 cronicas": "1 Crónicas", "1 crón": "1 Crónicas", "1cr": "1 Crónicas",
  "2 crónicas": "2 Crónicas", "2 cronicas": "2 Crónicas", "2 crón": "2 Crónicas", "2cr": "2 Crónicas",
  "esdras": "Esdras", "esd": "Esdras",
  "nehemías": "Nehemías", "nehemias": "Nehemías", "neh": "Nehemías",
  "ester": "Ester", "est": "Ester",
  // Poéticos
  "job": "Job",
  "salmos": "Salmos", "salmo": "Salmos", "sal": "Salmos", "ps": "Salmos", "sl": "Salmos",
  "proverbios": "Proverbios", "prov": "Proverbios", "pr": "Proverbios",
  "eclesiastés": "Eclesiastés", "ecclesiastes": "Eclesiastés", "ecl": "Eclesiastés", "ec": "Eclesiastés",
  "cantares": "Cantares", "cantaresdesalomón": "Cantares", "cnt": "Cantares", "ct": "Cantares",
  // Profetas mayores
  "isaías": "Isaías", "isaias": "Isaías", "is": "Isaías",
  "jeremías": "Jeremías", "jeremias": "Jeremías", "jer": "Jeremías",
  "lamentaciones": "Lamentaciones", "lam": "Lamentaciones",
  "ezequiel": "Ezequiel", "ez": "Ezequiel", "ezeq": "Ezequiel",
  "daniel": "Daniel", "dan": "Daniel", "dn": "Daniel",
  // Profetas menores
  "oseas": "Oseas", "os": "Oseas",
  "joel": "Joel", "jl": "Joel",
  "amós": "Amós", "amos": "Amós", "am": "Amós",
  "abdías": "Abdías", "abdias": "Abdías", "abd": "Abdías",
  "jonás": "Jonás", "jonas": "Jonás", "jon": "Jonás",
  "miqueas": "Miqueas", "miq": "Miqueas", "mi": "Miqueas",
  "nahúm": "Nahúm", "nahum": "Nahúm", "nah": "Nahúm",
  "habacuc": "Habacuc", "hab": "Habacuc",
  "sofonías": "Sofonías", "sofonias": "Sofonías", "sof": "Sofonías",
  "hageo": "Hageo", "hag": "Hageo",
  "zacarías": "Zacarías", "zacarias": "Zacarías", "zac": "Zacarías",
  "malaquías": "Malaquías", "malaquias": "Malaquías", "mal": "Malaquías",
  // NT — Evangelios
  "mateo": "Mateo", "mat": "Mateo", "mt": "Mateo",
  "marcos": "Marcos", "mar": "Marcos", "mc": "Marcos", "mr": "Marcos",
  "lucas": "Lucas", "luc": "Lucas", "lc": "Lucas",
  "juan": "Juan", "jn": "Juan",
  // Hechos
  "hechos": "Hechos", "hch": "Hechos", "act": "Hechos",
  // Cartas de Pablo
  "romanos": "Romanos", "rom": "Romanos", "ro": "Romanos",
  "1 corintios": "1 Corintios", "1corintios": "1 Corintios", "1 cor": "1 Corintios", "1co": "1 Corintios",
  "2 corintios": "2 Corintios", "2corintios": "2 Corintios", "2 cor": "2 Corintios", "2co": "2 Corintios",
  "gálatas": "Gálatas", "galatas": "Gálatas", "gál": "Gálatas", "gal": "Gálatas",
  "efesios": "Efesios", "ef": "Efesios",
  "filipenses": "Filipenses", "fil": "Filipenses", "flp": "Filipenses",
  "colosenses": "Colosenses", "col": "Colosenses",
  "1 tesalonicenses": "1 Tesalonicenses", "1 tes": "1 Tesalonicenses", "1ts": "1 Tesalonicenses",
  "2 tesalonicenses": "2 Tesalonicenses", "2 tes": "2 Tesalonicenses", "2ts": "2 Tesalonicenses",
  "1 timoteo": "1 Timoteo", "1timoteo": "1 Timoteo", "1 tim": "1 Timoteo", "1ti": "1 Timoteo",
  "2 timoteo": "2 Timoteo", "2timoteo": "2 Timoteo", "2 tim": "2 Timoteo", "2ti": "2 Timoteo",
  "tito": "Tito", "tit": "Tito", "tt": "Tito",
  "filemón": "Filemón", "filemon": "Filemón", "flm": "Filemón",
  "hebreos": "Hebreos", "heb": "Hebreos",
  // Cartas generales
  "santiago": "Santiago", "stg": "Santiago", "sant": "Santiago",
  "1 pedro": "1 Pedro", "1pedro": "1 Pedro", "1 pe": "1 Pedro", "1p": "1 Pedro",
  "2 pedro": "2 Pedro", "2pedro": "2 Pedro", "2 pe": "2 Pedro", "2p": "2 Pedro",
  "1 juan": "1 Juan", "1juan": "1 Juan", "1 jn": "1 Juan",
  "2 juan": "2 Juan", "2juan": "2 Juan", "2 jn": "2 Juan",
  "3 juan": "3 Juan", "3juan": "3 Juan", "3 jn": "3 Juan",
  "judas": "Judas", "jud": "Judas",
  "apocalipsis": "Apocalipsis", "ap": "Apocalipsis", "apoc": "Apocalipsis", "rev": "Apocalipsis",
};

// Reference pattern: (optional number + book name) + chapter + optional :verse(-verse)
const REF_RE = /(?:^|\s)(\d\s*)?([A-Za-záéíóúüñÁÉÍÓÚÜÑ]+(?:\s[A-Za-záéíóúüñÁÉÍÓÚÜÑ]+)?)\s+(\d+)(?::(\d+)(?:-(\d+))?)?/g;

/**
 * Parse a Bible reference from text.
 * @param {string} text
 * @returns {{ book: string, chapter: number, verseStart: number|null, verseEnd: number|null, raw: string } | null}
 */
export function parseReference(text) {
  REF_RE.lastIndex = 0;
  let match;
  while ((match = REF_RE.exec(text)) !== null) {
    const prefix    = (match[1] ?? "").trim();
    const bookRaw   = (prefix ? prefix + " " : "") + match[2];
    const canonical = BOOK_ALIASES[bookRaw.toLowerCase().trim()];
    if (!canonical) continue;

    return {
      book:       canonical,
      chapter:    parseInt(match[3], 10),
      verseStart: match[4] != null ? parseInt(match[4], 10) : null,
      verseEnd:   match[5] != null ? parseInt(match[5], 10) : null,
      raw:        match[0].trim(),
    };
  }
  return null;
}

/**
 * Format a canonical reference string.
 * e.g. { book: "Juan", chapter: 3, verseStart: 16 } → "Juan 3:16"
 */
export function formatReference({ book, chapter, verseStart, verseEnd }) {
  if (!verseStart) return `${book} ${chapter}`;
  if (verseEnd && verseEnd !== verseStart) return `${book} ${chapter}:${verseStart}-${verseEnd}`;
  return `${book} ${chapter}:${verseStart}`;
}

/**
 * Detect a Bible version code mentioned in text.
 * Returns the first matched code or null.
 */
const VERSION_PATTERNS = [
  { code: "rvr60", re: /rvr\s*60|reina\s*valera\s*1960|rv\s*60/i },
  { code: "nbla",  re: /nbla|nueva\s*biblia\s*latinoamericana/i },
  { code: "nvi",   re: /nvi|nueva\s*versión\s*internacional/i },
];

export function detectVersionInText(text) {
  for (const { code, re } of VERSION_PATTERNS) {
    if (re.test(text)) return code;
  }
  return null;
}
